import { render, staticRenderFns } from "./newspaperLayout.vue?vue&type=template&id=6eb05476&scoped=true&"
import script from "./newspaperLayout.vue?vue&type=script&lang=js&"
export * from "./newspaperLayout.vue?vue&type=script&lang=js&"
import style0 from "./newspaperLayout.vue?vue&type=style&index=0&id=6eb05476&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb05476",
  null
  
)

export default component.exports